import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import LockOutlineIcon from 'mdi-react/LockOutlineIcon';
import moment from 'moment';
import validate from './userValidate';
import renderField from '../../../shared/components/custom/Field';
import ChoiceCards from '../../../shared/components/custom/ChoiceCards';
import FormCard from '../../../shared/components/custom/FormCard';
import { partial } from '../../../util/translation/translation';

const p = partial('UserForm');
const s = partial('shared');

class UserForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    user: PropTypes.shape({
      firstname: PropTypes.string,
      lastname: PropTypes.string,
      country_code: PropTypes.number,
      username: PropTypes.string,
      email: PropTypes.string,
      zip: PropTypes.string,
      date_of_birth: PropTypes.string,
      gender: PropTypes.string,
      verified: PropTypes.number,
      companies: PropTypes.array,
    }),
    initialize: PropTypes.func.isRequired,
    me: PropTypes.shape({
      permissions: PropTypes.arrayOf(PropTypes.string),
    }),
  };

  static defaultProps = {
    me: undefined,
    user: null,
  };

  state = {
    showPassword: false,
    hasInitialized: false,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.user !== null && this.state.hasInitialized === false) {
      this.props.initialize({
        firstName: nextProps.user.firstname,
        lastName: nextProps.user.lastname,
        countryCode: nextProps.user?.countryCode?.toString(),
        username: nextProps.user.username,
        email: nextProps.user.email,
        postalCode: nextProps?.user?.zip?.toString(),
        birthday: nextProps.user.dateOfBirth
          ? moment(nextProps.user.dateOfBirth).format('YYYY-MM-DD')
          : '',
        gender: nextProps.user.gender,
        verified: !!nextProps.user.verified,
      });
      this.setState({ hasInitialized: true });
    }
  }

  render() {
    const isCreate = this.props.type === 'create';
    const isEdit = !!this.props.user;
    // Shown on fields that come from the user's account
    const lockIcon = (
      <LockOutlineIcon
        size={13}
        className="user-form__lock"
        aria-label={p('lockedField')}
      />
    );
    return (
      <form className="form user-form" onSubmit={this.props.handleSubmit}>
        <div className="user-layout">
          <FormCard title={p('personalDetails')}>
            <p className="user-form__hint">
              {isEdit ? p('personalDetailsHintEdit') : p('personalDetailsHint')}
            </p>
            <div className="form-grid">
              <div className="form__form-group">
                <span className="form-header">
                  {s('firstname')}
                  {isEdit && lockIcon}
                </span>
                <Field
                  name="firstName"
                  component={renderField}
                  type="text"
                  placeholder={p('placeHolderFirstname')}
                  disabled={isEdit}
                />
              </div>
              <div className="form__form-group">
                <span className="form-header">
                  {s('lastname')}
                  {isEdit && lockIcon}
                </span>
                <Field
                  name="lastName"
                  component={renderField}
                  type="text"
                  placeholder={p('placeHolderLastName')}
                  disabled={isEdit}
                />
              </div>
              <div className="form__form-group">
                <span className="form-header">{s('dateOfBirth')}</span>
                <Field name="birthday" component={renderField} type="date" />
              </div>
              <div className="form__form-group">
                <span className="form-header">{s('postCode')}</span>
                <Field
                  name="postalCode"
                  component={renderField}
                  type="number"
                  placeholder="1234"
                />
              </div>
              <div className="form__form-group form-grid__full">
                <span className="form-header">{s('sex')}</span>
                <Field
                  name="gender"
                  component={ChoiceCards}
                  ariaLabel={s('sex')}
                  options={[
                    { value: 'male', label: s('man') },
                    { value: 'female', label: s('woman') },
                  ]}
                />
              </div>
            </div>
          </FormCard>

          {/* Right column: Contact, then any extra sections from the page
            (e.g. Access) underneath it */}
          <div className="user-layout__col">
            <FormCard title={p('contactDetails')}>
              <p className="user-form__hint">{p('contactDetailsHint')}</p>
              <div className="form-grid user-form__contact">
                <div className="form__form-group">
                  <span className="form-header">
                    {s('countryCode')}
                    {isEdit && lockIcon}
                  </span>
                  <Field
                    name="countryCode"
                    component={renderField}
                    type="number"
                    placeholder={s('countryCodePlaceHolder')}
                    disabled={isEdit}
                  />
                </div>
                <div className="form__form-group">
                  <span className="form-header">
                    {p('username(Phonenumber)')}
                  </span>
                  <Field
                    name="username"
                    component={renderField}
                    type="text"
                    placeholder="12345678"
                  />
                </div>
                <div className="form__form-group form-grid__full">
                  <span className="form-header">
                    {s('email')}
                    {isEdit && lockIcon}
                  </span>
                  <Field
                    name="email"
                    component={renderField}
                    type="text"
                    placeholder={isCreate ? s('email') : ''}
                    disabled={isEdit}
                  />
                </div>
                {isCreate && (
                  <div className="form__form-group form-grid__full">
                    <span className="form-header">{s('password')}</span>
                    <Field
                      name="password"
                      component={renderField}
                      type={this.state.showPassword ? 'text' : 'password'}
                      placeholder={s('password')}
                    />
                  </div>
                )}
              </div>
            </FormCard>
            {this.props.children}
          </div>
        </div>

        <div className="messages-form__footer">
          <span />
          <div className="messages-form__secondary">
            <Link to="/users" className="btn btn-outline-secondary btn-sm mb-0">
              {s('close')}
            </Link>
            <Button type="submit" color="primary" size="sm" className="mb-0">
              {s('save')}
            </Button>
          </div>
        </div>
      </form>
    );
  }
}

const reduxF = reduxForm({
  form: 'UserForm',
  validate,
});

export default withRouter(
  connect((state) => ({
    me: state.admin.me,
  }))(reduxF(UserForm))
);
